import { SORT_DIRECTIONS } from './TooltipedSortLabel.constants';

const DIRECTION_LIMIT = 180;

export const getWrapperStyles = align => ({
  display: 'flex',
  gap: '10px',
  justifyContent: align,
});

export const getIconWrapperStyles = direction => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'transform 0.3s ease',
  transform: `rotate(${direction === SORT_DIRECTIONS.DESC ? 0 : DIRECTION_LIMIT}deg)`,
});

export const labelStyles = {
  fontSize: '14px',
  fontWeight: 500,
};

export const getFilterWrapperStyles = align => ({
  ...getWrapperStyles(align),

  '& .column-filter-icon': {
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },

  '& .column-filter-icon.filter-active': {
    opacity: 1,
  },

  '&:hover .column-filter-icon': {
    opacity: 1,
  },
});
